import Edit from "./Edit";
import List from "./List";
import New from "./New";

export default {
  Edit,
  List,
  New
};
